import { Typography } from 'antd';
import classNames from 'classnames';
import React, { FC } from 'react';
import styles from 'components/organisms/document/parts/doc-discussions/discussions-components/discussions-components.module.css';

interface TextFromDocProps {
  content: string;
  onClick?: (id: string) => void;
  linkedId?: string;
  contentType: 'private' | 'public';
  noShadow?: boolean;
}
const { Paragraph } = Typography;

export const TextFromDoc: FC<TextFromDocProps> = ({
  content,
  onClick,
  linkedId = '',
  contentType,
  noShadow,
}) => {
  const stylesContentModifier = {
    public: styles.content__public,
    private: styles.content__private,
  };
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();

    return onClick?.(linkedId);
  };

  return (
    <a
      href={`#rl-comment-${linkedId || ''}`}
      onClick={handleClick}
      className={`${styles.doc__snippet} ${noShadow ? styles.no_shadow : ''}`}
    >
      <Paragraph ellipsis={{ rows: 1 }}>
        <span className={classNames(stylesContentModifier[contentType])}>
          {content}
        </span>
      </Paragraph>
    </a>
  );
};
